import {FC, useState} from 'react'
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
  ThemeModeSwitcher,
} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {Link} from 'react-router-dom'

const itemClass = 'ms-1 ms-lg-3',
  btnClass = 'btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px',
  userAvatarClass = 'symbol-30px symbol-md-40px',
  btnIconClass = 'fs-1'
const Topbar: FC = () => {
  const {config} = useLayout()
  const API_URL = process.env.REACT_APP_API_URL
  const pdp_url = `${API_URL}/uploads/pdp/`
  const {currentUser, logout} = useAuth()
  const photo = currentUser?.photoProfil ? `${pdp_url}${currentUser?.photoProfil}` : toAbsoluteUrl('/media/avatars/blank.png');

    return (
    <div className='d-flex align-items-stretch justify-self-end flex-shrink-0'>
      {/* Search */}
      {/*<div className={clsx('d-flex align-items-stretch', itemClass)}>
        <Search />
      </div>*/}
      {/* Activities */}
      {/*<div className={clsx('d-flex align-items-center', itemClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary btn-custom', btnClass)}
          id='kt_activities_toggle'
        >
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div>*/}

      {/* NOTIFICATIONS */}
      {/*<div className={clsx('d-flex align-items-center', itemClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary position-relative ', btnClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>*/}

      {/* CHAT */}
      {/*<div className={clsx('d-flex align-items-center', itemClass)}>
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative',
            btnClass
          )}
          id='kt_drawer_chat_toggle'
        >
          <KTIcon iconName='message-text-2' className={btnIconClass} />

          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'></span>
        </div>
      </div>*/}

      {/* Quick links */}
      {/*<div className={clsx('d-flex align-items-center', itemClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary btn-custom', btnClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <KTIcon iconName='element-11' className={btnIconClass} />
        </div>
        <QuickLinks />
      </div>*/}

      {/* begin::Theme mode */}
      {/*<div className={'d-flex align-items-center ms-1 ms-lg-3'}>*/}
      {/*  <ThemeModeSwitcher toggleBtnClass='btn-active-light-primary w-30px h-30px w-md-40px h-md-40px' />*/}
      {/*</div>*/}
      {/* end::Theme mode */}

      {/* begin::Documentation */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        <Link
          to='/documentation'
          className={clsx('btn btn-icon btn-active-light-primary', btnClass)}
          title='Documentation'
        >
          <i className='bi bi-question-circle fs-2'></i>
        </Link>
      </div>
      {/* end::Documentation */}

      {/* begin::User */}
      <div className={clsx('d-flex align-items-center', itemClass)} id='kt_header_user_menu_toggle'>
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={photo} alt={currentUser?.prenom} />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTIcon iconName='text-align-left' className='fs-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export {Topbar}
